module.exports = __webpack_public_path__ + "img/red_011.587e6c1a.png";